import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from '../../../shared/api.service';
import { Router } from '@angular/router';
import { EventSendeurService } from '../../../shared/event-sendeur.service';
import { NbToastrService, NbDialogRef, NbDialogService } from '@nebular/theme';
import { Categorie } from '../../../shared/data/categorie';
import { plainToClass } from 'class-transformer';
import { Formation } from '../../../shared/data/formation';
import { Critere } from '../../../shared/data/critere';
import { EditCritereComponent } from '../../criteres/edit-critere/edit-critere.component';

@Component({
  selector: 'ngx-edit-formation',
  templateUrl: './edit-formation.component.html',
  styleUrls: ['./edit-formation.component.scss']
})
export class EditFormationComponent implements OnInit {
  @Input() id: number;
  /* nome;
  desc;
  cate:any = []; */
  formt = new Formation;
  hideLoader =true;
  hideButon =false;
  // pr;

  selectedItems = [];
  dropdownSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'chemin',
    selectAllText: 'Selectionner tous',
    unSelectAllText: 'Déselectionner tout',
    itemsShowLimit: 3,
    allowSearchFilter: true,
    closeDropDownOnSelection: true,
  };

  formations: any[];
  options: Critere[] = [];

  constructor(protected dialogRef: NbDialogRef<EditFormationComponent>,private apiService:ApiService, private dialogService: NbDialogService, private router:Router,private sendeurService:EventSendeurService, public toastr: NbToastrService) {
  
    if( this.id !== 0 )
    this.getFormations();

  }

  ngOnInit() {

    if(this.id !== 0)
    this.getOneFormation();

    this.apiService.getAllCritereProvider('').subscribe(data =>{
     
        this.options = data;
    })

    this.sendeurService.critereEvent.subscribe( data => {

      console.log(data)
      
      const index = this.options.findIndex(elem => elem.id ===  data.id);

      if(index === -1 ) {

        this.options.push(data);

        if(data.type_critere === 'catformation')
        this.formt.categorie = data.id;

      }

    }) 
   
  }

  cancel(){
    this.dialogRef.close();
    
    
  }

  close(){
    this.dialogRef.close();
    
    
  }

  

  updateFormation(){

    if( this.id !== 0 ) {

      this.hideButon= true;
      this.hideLoader = false;
      this.apiService.updateFormationProvider(this.formt).subscribe((data:Formation) =>{
        console.log(data);
        this.toastr.success("mise à jour réussie","success");
        this.dialogRef.close();
        this.sendeurService.sendFormationEvent(data); 

      },(err) =>{
        console.log(err);
        this.toastr.danger("echec de mise à jour réussie, le nom de cette formation existe peut être déjà");
        this.hideButon= false;
        this.hideLoader = true;
        if(err.error.code ===401){
          localStorage.clear();
          window.location.reload();
          let link2 = ['/login'];
          this.router.navigate(link2);
        }

        if(err.error.code ===500){
        
            this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
        }
    
      })

    } else {


      this.hideLoader = false;
      this.hideButon = true;
      

      this.apiService.addFormationProvider(this.formt).subscribe((data:Formation) =>{
        console.log(data);
        this.toastr.success("Formation crée avec success");
        this.dialogRef.close();
        this.sendeurService.sendFormationEvent(data); 
      },(err) =>{
        this.hideLoader = true;
        this.hideButon = false;
        this.toastr.danger("Il se peut qu'une formation portant le meme nom existe déjà","erreur");
        console.log(err);
      
        if(err.error.code ===401){
          localStorage.clear();
          window.location.reload();
          let link2 = ['/login'];
          this.router.navigate(link2);
        }

        if(err.error.code ===500){
          this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page","echec");
        }
    
    })



    }
    
  }

  getOneFormation(){

    this.apiService.getOneFormationProvider(this.id).subscribe(data =>{
     this.formt = plainToClass(Formation, data as object);
     this.selectedItems = [this.formt.parent];

     this.getFormations();

    },(err) =>{

      if(err.error.code ===401){
        localStorage.clear();
        window.location.reload();
        let link2 = ['/login'];
        this.router.navigate(link2);
      }

      if(err.error.code ===500){
      
        this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
      }

    })
  }

  getFormations(){

      this.apiService.getAllformationProvider('').subscribe(data =>{
      
      // une categorie ne doit pas avoir comme parent elle-même ou un de ces fils
      const fors: Formation[] = data as any[];

      if( this.formt.id !== 0) {

        const index = fors.findIndex( item =>item.id === this.formt.id);
        if(index > -1)
        fors.splice(index,1);

      }

      /* if( this.formt.id !== 0 && this.formt.descendant !== undefined && this.formt.descendant !== null) {

        this.formt.descendant.forEach(element => {

          const index = cats.findIndex( item =>item.id === element);
          if(index > -1)
          fors.splice(index,1);
          
        });

      } */

      this.formations = fors;
     
      /* const tmps = data as any[];   
      this.categories = tmps.map(tmp => {
        return {
        
          nom: tmp.nom,   
          id:tmp.id,
          description:tmp.description
        };
      
      }); */

    })
    
  }


  onItemSelect(data: any) {

   this.formt.parent = data;

   /* if(this.formations !== undefined) {

    const index = this.formations.findIndex( item=>item.id === data.id)
    if( index > -1 ){
      const parent: Formation = this.formations[index];
      // this.formt.type_content = parent.type_content;
    }

   } */

   
  }

  
  onItemDeSelect(item: any){

    this.formt.parent = null;

  }

  onSelectAll(items: any) {
    
  }

  onDeSelectAll($event){
    
  }

  onUnSelectAll(){
    
  }

  onDropDownClose($event){
    
  }

  /* typeCatChanged($event){

    this.cat.type_content = $event;

  } */

  addCategorie() {
    this.dialogService.open(EditCritereComponent,{context:{id:0, typecrit:'catformation'}});
  }


  /* addAdmissibility() {
    this.dialogService.open(EditCritereComponent,{context:{id:0, typecrit:'admissibility'}});
  } */


}
